/* eslint no-param-reassign: "error" */
import { createSlice } from '@reduxjs/toolkit';
import sumBy from 'lodash-es/sumBy';

const initialState = {
  data: {},
  maxAvailability: 0,
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProduct(state, action) {
      const { payload } = action;
      let maxAvailability = 0;

      if (payload.capacity.type === 0 || payload.capacity.type === 2) {
        maxAvailability = payload.capacity.quantity;
      } else if (payload.capacity.type === 1) {
        maxAvailability = payload.capacities ? sumBy(payload.capacities.option_capacities, 'capacity') : 0;
      }

      state.data = payload;
      state.maxAvailability = maxAvailability;
    },
  },
});

export const { setProduct } = productsSlice.actions;

export default productsSlice.reducer;
